<template>
  <!-- 绑定搜知账号 -->
  <div>
    <h1 style="font-weight: bold">
      <span @click="back" style="cursor: pointer"><left-Outlined/></span>完善账号信息
    </h1>
    <div style="text-align: center">
      <a-upload
        v-model:file-list="fileList"
        name="file"
        :show-upload-list="false"
        :action="actionUrl"
        accept=".jpg,.png,.gif,.jpeg,.JPG,.PNG,.GIF,.JPEG"
        :before-upload="beforeUpload"
        @change="handleChange"
      >
        <img
          v-if="imageUrl"
          :src="imgSiteUrl + imageUrl"
          alt="avatar"
          style="
            height: 80px;
            width: 80px;
            border-radius: 50%;
            margin-top: 10px;
          "
        />
        <div v-else>
          <div class="iconPlus">
            <img src="~@/assets/img/upload.png" alt="" />
          </div>
          <div style="margin-top: 10px;color: #333;font-size:15px">上传头像</div>
        </div>
      </a-upload>
    </div>
    <div class="name">昵称<span style="color: red">*</span></div>
    <a-input
      style="width: 440px;background: #f3f3f4;height:44px"
      placeholder="请输入您的昵称"
      v-model:value="nickName"
    ></a-input>
    <div class="sketch">一句话介绍</div>
    <a-textarea
      style="width: 440px; margin-bottom: 10px"
      placeholder="简单介绍一下自己吧~"
      :auto-size="{ minRows: 5, maxRows: 5 }"
      v-model:value="presonalProfile"
    />
    <a-button
      type="button"
      style="width: 225px; margin-top: 10px; background: #393939; color: white;height: 44px;font-size:16px"
      @click="goGuidance"
      >确定</a-button
    >
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import Http from "../../until/http";
import { LeftOutlined } from "@ant-design/icons-vue";
import config from "../..//until/configs";
import {
  getCookie,
  messageTips,
  setCookie,
  setLocalItem,
  delCookie,
} from "../../until/tools";
// function getBase64(img, callback) {
//   const reader = new FileReader();
//   reader.addEventListener("load", () => callback(reader.result));
//   reader.readAsDataURL(img);
// }
export default defineComponent({
    components: {
    LeftOutlined,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      nickName: "",
      presonalProfile: "",
      sid: getCookie("z_sid"),
      fileList: [],
      actionUrl: config.uploadLoginImage + "?sid=" + getCookie("z_sid"),
      imgSiteUrl: config.imgSiteUrl,
    });
    //图片数据
    // const fileList = ref([]);
    const imageUrl = ref("");
    const handleChange = (info) => {
      if (info.file.status === "done") {
        // getBase64(info.file.originFileObj, (base64Url) => {
        //   imageUrl.value = base64Url;
        // });
        imageUrl.value = info.file.response.url;
      }

      if (info.file.status === "error") {
        messageTips("上传错误", 1);
      }
    };
    const beforeUpload = (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";

      if (!isJpgOrPng) {
        messageTips("您只能上传JPG文件", 1);
      }

      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        messageTips("图片必须小于2MB!", 1);
      }

      return isJpgOrPng && isLt2M;
    };

    const goGuidance = (e) => {
      e.preventDefault();
      if (state.nickName === "") {
        messageTips("请输入昵称", 2);
        return false;
      }
      Http.login({
        account: route.query.account,
        verifyCode: route.query.verifyCode.slice(0, 6),
        loginType: 0,
        userName: state.nickName,
        presonalProfile: state.presonalProfile,
        imgUrl: imageUrl.value,
        openSid: route.query.openSid
          ? route.query.openSid.split("?")[0]
          : undefined,
      }).then((res) => {
        if (!res.success) {
          messageTips(res.message, 1);
          router.go(-1);
          return false;
        }
        setCookie("userId", res.userInfo.userId, { time: 1 });
        setCookie("z_sid", res.sid, 1);
        setLocalItem("isUserLogin", {
          isUserLogin: res.isUserLogin,
        });
        Http.getUserInfo().then((res) => {
          if (res.userInfo) {
            setLocalItem("userInfo", res.userInfo);
            if (route.query.sign == 66) {
              window.location.href =
                "http://test.sozdata.com/site.html#/index";
            } else if (route.query.sign == 88) {
              window.location.href =
                "http://test.sozdata.com/tqexam.html#/user/signUp";
            } else {
              if (route.query.sign == 66) {
                window.location.href =
                  "http://test.sozdata.com/site.html#/index";
              } else if (route.query.sign == 88) {
                window.location.href =
                  "http://test.sozdata.com/tqexam.html#/match";
              } else {
                setCookie("isNewReg", 1, { time: 1 });
                router.push("/login/guidance");
              }
            }
          }
        });
      });
    };
    const back=()=>{
      router.go(-1)
    }

    onMounted(() => {
      if (getCookie("z_sid")) {
        let locationTarget = getCookie("locationTarget");
        if (locationTarget) {
          delCookie("locationTarget");
          window.location.href = locationTarget;
        } else {
          router.push("/");
        }
      }
    });

    return {
      goGuidance,
      ...toRefs(state),
      imageUrl,
      handleChange,
      beforeUpload,
      back
    };
  },
});
</script>

<style lang="scss" scoped>
/deep/.ant-btn:focus,/deep/ .ant-btn:hover {
    border-color: #fff;
}
.iconPlus {
  margin-top: 20px;
  text-align: center;
  height: 70px;
  line-height: 63px;
  width: 70px;
  // font-size: 40px;
  border: 1px solid #e8e8e8;
  border-radius: 50%;
  img {
    width: 46%;
  }
}
.name {
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 16px;
  color: #333;
  font-weight: bold;
}
.sketch {
  margin-top: 30px;
  margin-bottom: 10px;
  font-size: 16px;
  color: #333;
  font-weight: bold;
}
</style>